'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('role-edit', {
      url: '/admin/roles/edit',
      template: '<role-edit></role-edit>',
      authenticate: 'suite-superadmin'
    });
}



// WEBPACK FOOTER //
// ./client/app/admin/role-edit/role-edit.routes.js